import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { Trans } from 'react-i18next'
import { createUseStyles } from 'react-jss'
import { addAuthContext } from 'shared/src/utils/auth'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { ConstrainWidth, LAYOUT_MAX_WIDTH } from 'utils/layout'
import { sansSerifFontFamily, serifFontFamily } from 'utils/styles'
import { REGISTER_Z_INDEX } from 'utils/zIndex'
import lasso from '../../assets/edits-register-lasso.svg'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: REGISTER_Z_INDEX,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    maxWidth: LAYOUT_MAX_WIDTH,
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  lasso: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
    zIndex: 0,
    maxWidth: LAYOUT_MAX_WIDTH - 40,
    maxHeight: LAYOUT_MAX_WIDTH - 40,
  },
  title: {
    fontFamily: serifFontFamily,
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '140%',
    color: '#FDFDFD',
    maxWidth: 239,
    marginBottom: 16,
  },
  description: {
    fontFamily: sansSerifFontFamily,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '140%',
    color: 'rgba(253, 253, 253, 0.8)',
    maxWidth: 253,
    marginLeft: 16,
    marginBottom: 32,
  },
  registerButton: {
    minWidth: 168,
    height: 56,
    border: 'none',
    borderRadius: 16,
    color: '#000',
    fontFamily: sansSerifFontFamily,
    fontWeight: 800,
    fontSize: 14,
    lineHeight: '17px',
    letterSpacing: '0.1em',
  },
  logInButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    position: 'absolute',
    bottom: 24,
    fontFamily: sansSerifFontFamily,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    color: 'rgba(253, 253, 253, 0.8)',
    textAlign: 'center',
  },
  logIn: {
    fontWeight: 900,
    color: '#CBA67A',
  },
})

export const Register: FC = flowMax(
  addDisplayName('Register'),
  addAuthContext,
  addHandlers({
    onRegister:
      ({ navigateToRegister }) =>
      () => {
        navigateToRegister({})
      },
    onLogIn:
      ({ navigateToLogin }) =>
      () => {
        navigateToLogin({ loginTrigger: 'view_edit' })
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ onRegister, onLogIn, classes, t }) => (
    <ConstrainWidth fillHeight>
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <img src={lasso} alt="" className={classes.lasso} />
          <div className={classes.title}>{t('edits.login.title')}</div>
          <div className={classes.description}>
            {t('edits.login.description')}
          </div>
          <button onClick={onLogIn} className={classes.registerButton}>
            {t('edits.login.loginButton')}
          </button>
        </div>
        <button onClick={onRegister} className={classes.logInButton}>
          <Trans t={t} i18nKey="edits.login.register">
            <span className={classes.logIn} />
          </Trans>
        </button>
      </div>
    </ConstrainWidth>
  )
)
